export default __webpack_public_path__ + "static/media/ComparativoOn.b3aa9913.png";